$(window).on('load', function () {
    let store_label_checked = $(document).find(".itgoption_stone input:checked").attr('color-value');
    let updateCount = 0;
    $("#itg_stone_table tr").each(function () {
        let var_stone_name = $(this).data('stone-name');
        console.log('var_stone_name', var_stone_name);
        console.log('updateCount', updateCount);
        if (store_label_checked === var_stone_name) {
            if (updateCount < 2) {
                $(this).addClass("itg_stone_varint");
                updateCount++;
            }
        }
        else {
            $(this).removeClass("itg_stone_varint");
        }
    });
    $(".itg_search_grid").slice(0, 8).show();
});


$(document).ready(function(){
    $(document).on("click",".itg_cart cart-remove-button",function() {
        setTimeout(function(){
            location.reload();
        }, 1000);
    });

// ----------product_related----------- 
    $('.itg_product_related_slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 25" fill="none"><path d="M13 24.5L1 12.5L13 0.5" stroke="#3F434A" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
        nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 25" fill="none"><path d="M1 24.5L13 12.5L1 0.5" stroke="#3F434A" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
        arrows: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
// ----------end product_related----------- 



    $('.itg_grid_box ul').on('click', 'li', function() {
        $('.itg_grid_box ul li.active').removeClass('active');
        $(this).addClass('active');
    });


// ----------collection loadMore----------- 
    $(".itg_coll_grid").slice(0, 9).show();
    $("#loadMore").on("click", function(e){
        e.preventDefault();
        $(".itg_coll_grid:hidden").slice(0, 9).slideDown();
        if ($(".itg_coll_grid:hidden").length == 0) {
            $("#loadMore").text("No Content").addClass("noContent");
        }
    });
// ----------end collection loadMore-----------



// ----------search collection----------- 

    $(".itg_search_grid").slice(0, 8).show();
    $("#searchload").click(function(e){
        e.preventDefault();
        $(".itg_search_grid:hidden").slice(0, 8).slideDown();
        if ($(".itg_search_grid:hidden").length == 0) {
            $("#searchload").text("No Content").addClass("noContent");
        }
    });
// ----------end search collection-----------

    // ----------collection grid-----------  
    $('.two_svg').click(function(){
        $('#product-grid').addClass("grid--2-col-desktop");
        $('#product-grid').removeClass("grid--4-col-desktop").removeClass("grid--3-col-desktop");
    });
    $(".three_svg").click(function(){
        $('#product-grid').addClass("grid--3-col-desktop");
        $('#product-grid').removeClass("grid--4-col-desktop").removeClass("grid--2-col-desktop");
    });
    $(".four_svg").click(function(){
        $('#product-grid').addClass("grid--4-col-desktop");
        $('#product-grid').removeClass("grid--3-col-desktop").removeClass("grid--2-col-desktop");
    });
// ----------end collection grid-----------  

// ----------maxwidth slider-----------
    width = $( window ).width();
    if ($(window).width()>990) {
        $('.itg_vertical').removeClass('product--thumbnail_slider');
        $('.itg_vertical').addClass('product--thumbnail');
    }

// var maxwidth = 750;
    function createSlick(){
        $(".itg_vertical .thumbnail-list").not('.slick-initialized').slick({
            arrows: true,
            vertical: true,
            verticalSwiping: true,
            infinite: false,
            focusOnSelect: false,
            speed: 300,
            slidesToShow: 5,
            prevArrow: '<span class="slide-arrow prev-arrow"><svg  width="22" height="20" viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></span>',
            nextArrow: '<span class="slide-arrow next-arrow"><svg width="22" height="20" viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></span>',
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 991,
                settings: 'unslick'
            }
            ]
        });

    }
    createSlick();
    $(window).on( 'resize', createSlick );

// ----------slick active------------  
// $('.itg_vertical .thumbnail-list').on('beforeChange', function(event, slick, currentSlide, nextSlide){
//   $('.itg_stone_label .active').removeClass('active');
//   $('.itg_stone_label').eq(nextSlide).addClass('active');
// });
//  $('.itg_stone_label').on('click', function(e){
//   e.preventDefault();
//   $('.itg_stone_label .active').removeClass('active');
//   $(this).addClass('active');
//   var targetSlide = $(this).data('target');
//   $('.itg_vertical .thumbnail-list').slick('slickGoTo', targetSlide );
// });
// ----------end maxwidth slider-----------    

    // ----------product tab-----------  
    $('.tab-link:first-child').addClass('current');
    $(document).find('.tab-content').first().addClass('current');

    $('.product_descr_review ul.tabs li').click(function(){
        var tab_id = $(this).attr('data-tab');
        $('.product_descr_review ul.tabs li').removeClass('current');
        $('.product_descr_review .tab-content').removeClass('current');
        $(this).addClass('current');
        $("#"+tab_id).addClass('current');
    });
    // ----------end product tab-----------    


    $( ".itgoption_stone label" ).on( "click", function() {
        var ston_title = $(this).data("label-title");
        $(".itg_label_title").text(ston_title);
    });

    var data_title = $('.product-form__input input[type=radio]:checked+.itg_stone_label').attr('data-label-title');
    $(".itg_label_title").text(data_title);


    $( ".itg_metal_color" ).on( "click", function() {
        var metal_color = $(this).data("metal-color");
        $(".itg_label_color").text(metal_color);
    });

    var data_color = $('.product-form__input input[type=radio]:checked+label.itg_metal_color').attr('data-metal-color');
    $(".itg_label_color").text(data_color);



    $( ".itg_stone_label" ).on( "click", function() {
        let var_store_label = $(this).data('label-title');
        let updateCount = 0;
        console.log('var_store_label', var_store_label);
        $("#itg_stone_table tr").each(function () {
            let var_stone_name = $(this).data('stone-name');
            console.log('var_stone_name', var_stone_name);
            console.log('updateCount', updateCount);
            console.log($(this));
            if (var_store_label === var_stone_name) {
                if (updateCount < 2) {
                    $(this).addClass("itg_stone_varint");
                    updateCount++;
                }
            }
            else {
                $(this).removeClass("itg_stone_varint");
            }
        });
    });


    // $( ".itg_stone_label" ).on( "click", function() {  
    //   var var_store_id = $(this).data('varint-id');
    //  $(".itg_item_description").each(function () {
    //     var var_item_description = $(this).data('description-id');
    //     if (var_store_id == var_item_description) {
    //       $(this).addClass("itg_stone_varint");
    //     } else {
    //       $(this).removeClass("itg_stone_varint");
    //     }
    //    }); 
    // });



    $( ".itg_dote" ).on( "click", function() {
        var pro_id = $(this).data("produt-id");
        $(".itg_custom_pro ul li").each(function () {
            var ckeckid  = $(this).data("produt-id");
            if (pro_id == ckeckid) {
                $(this).addClass("itg_show_product");
            } else {
                $(this).removeClass("itg_show_product");
            }
        });
    });


    $('#ring-size').on('change',function () {
        var ringval = $(this).find("option:selected").val();
        $("#itg_ring_size").val(ringval);
    });

    var ringval = $('#ring-size').find("option:selected").val();
    $("#itg_ring_size").val(ringval);


    $('#metal_type_selection').on('change',function () {
        var selval = $(this).find(":selected").attr('data-val');
        $(".itgoption_metal-type label").each(function () {
            var thslabel = $(this).attr('data-value');
            if (thslabel == selval){
                $(this).click();
            }
        });
    });


    var clr_value = $(document).find(".itgoption_color input:checked").attr('color-value');
    if (clr_value != '' && clr_value != undefined){
        $("#all_option_varaint > option").each(function() {
            var clr_name = $(this).attr('option2');
            if (clr_name == clr_value){
                var clr_stone = $(this).attr('option3');
                var clr_img = $(this).attr('data-img');
                $(".itgoption_stone img").each(function() {
                    var stone_name = $(this).attr('data-label-img');
                    if (stone_name == clr_stone){
                        $(this).attr('src',clr_img);
                    }
                });
            }
        });
    }

    $(document).on("click",".itgoption_color label",function() {
        var clr_value = $(this).attr('data-metal-color');
        if (clr_value != '' && clr_value != undefined){
            $("#all_option_varaint > option").each(function() {
                var clr_name = $(this).attr('option2');
                if (clr_name == clr_value){
                    var clr_stone = $(this).attr('option3');
                    var clr_img = $(this).attr('data-img');
                    $(".itgoption_stone img").each(function() {
                        var stone_name = $(this).attr('data-label-img');
                        if (stone_name == clr_stone){
                            $(this).attr('src',clr_img);
                        }
                    });
                }
            });
        }
    });
    $(document).on("change",".product-form__input input",function() {
        var selectedId = $(document).find('[name="id"].product-variant-id').attr('value');
//alert(selectedId)
        $(document).find('.itg_item_description').hide();
        $(document).find('[data-description-id="'+selectedId+'"]').show()
    });
});

